import React from 'react';
import ColorUtils from '../utils/colors'
import { Box, Typography } from '@mui/material';

export function KeyFeature(props) {
  return (
    <Box sx={{
      textAlign: 'center',
      color: '#1E293B',
      margin: '0rem auto',
      maxWidth: '22rem',
      padding: '3rem 2rem',
      borderRadius: '24px',
      transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
      cursor: 'default',
      backgroundColor: '#fff',
      border: '1px solid rgba(0,0,0,0.04)',
      boxShadow: '0 4px 20px rgba(0,0,0,0.02)',
      '&:hover': {
        transform: 'translateY(-10px)',
        boxShadow: '0 20px 40px rgba(0,0,0,0.06)',
        borderColor: 'rgba(0,0,0,0.08)',
        '& .icon-container': {
          transform: 'scale(1.1) rotate(8deg)',
          boxShadow: `0 12px 24px ${props.iconColor}30`,
        }
      }
    }}>
      <Box 
        className="icon-container"
        sx={{
          color: props.iconColor,
          width: '5rem',
          height: '5rem',
          margin: '0rem auto 2rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: props.iconColorBg || 'rgba(0,0,0,0.04)',
          borderRadius: '20px',
          transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
          '& i': { fontSize: '2.5rem', display: 'block' },
        }}
      >
        <i className={`iconfont ${props.icon}`}></i>
      </Box>
      <Typography 
        variant="h5" 
        sx={{ 
          fontSize: '1.4rem', 
          fontWeight: 800, 
          mb: 1.5,
          fontFamily: "'Poppins', sans-serif",
          color: '#1E293B'
        }}
      >
        {props.title}
      </Typography>
      <Typography 
        variant="body2" 
        sx={{ 
          lineHeight: 1.7, 
          color: '#64748B', 
          fontSize: '1rem',
          fontFamily: "'Inter', sans-serif"
        }}
      >
        {props.desc}
      </Typography>
    </Box>
  )
}

export default KeyFeature;